<template>
    <div class="service-builder__header">
        <div>
            <h5 class="service-builder__title" v-html="titleHtml"></h5>
            <div v-if="daysLabel" class="service-builder__meta">
                <span class="service-builder__meta-dot"></span>
                {{ daysLabel }}
            </div>
        </div>
        <div class="service-builder__actions">
            <button type="button" class="btn btn-sm btn-secondary btn-circle" @click.prevent="$emit('cancel')">
                {{ $tl("labels.form.actions.cancel") }}
            </button>
            <button type="submit" :form="formId" class="btn btn-sm btn-success btn-circle ms-2" :disabled="isSaving">
                {{ $tl("labels.form.actions.save") }}
            </button>
        </div>
    </div>
</template>

<script>
export default {
    name: "ServiceBuilderHeader",
    props: {
        titleHtml: {
            type: String,
            required: true,
        },
        daysLabel: {
            type: String,
            default: null,
        },
        formId: {
            type: String,
            default: "service-builder-form",
        },
        isSaving: {
            type: Boolean,
            default: false,
        },
    },
};
</script>
